"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getElementsForAppInstance(app) {
    var appTemplateId = app.templateId, appVersion = app.version;
    return getElementsForApp({ appTemplateId: appTemplateId, appVersion: appVersion });
}
exports.getElementsForAppInstance = getElementsForAppInstance;
function getElementsForManifest(manifest) {
    var appTemplateId = manifest.ksysAppTemplateId, version = manifest.version;
    var appVersion = version.startsWith('v') ? version : "v" + version;
    return getElementsForApp({ appTemplateId: appTemplateId, appVersion: appVersion });
}
exports.getElementsForManifest = getElementsForManifest;
function getElementsForApp(target) {
    var _a;
    var appTemplateId = target.appTemplateId, _b = target.appVersion, appVersion = _b === void 0 ? 'v1.0.0' : _b;
    var ksysAppTemplateIdDataKey = 'data-ksys-app-template-id';
    var ksysAppTemplateVersionDataKey = 'data-ksys-app-template-version';
    var elements = document.querySelectorAll("[" + ksysAppTemplateIdDataKey + "=\"" + appTemplateId + "\"]");
    var elementsWithCombinedVersion = document.querySelectorAll("[" + ksysAppTemplateIdDataKey + "=\"" + appTemplateId + "-" + appVersion + "\"]");
    var elementsCollection = [];
    if (elements) {
        elementsCollection = Array.from(elements);
        var versions = Object.keys(elementsCollection.reduce(function (acc, element) {
            var version = element.getAttribute(ksysAppTemplateVersionDataKey);
            if (version) {
                acc[version] = true;
            }
            return acc;
        }, (_a = {}, _a[appVersion] = true, _a)));
        if (versions && versions.length > 0) {
            var highestVersion_1 = versions.sort().reverse()[0];
            elementsCollection = elementsCollection.filter(function (element) {
                var version = element.getAttribute(ksysAppTemplateVersionDataKey);
                return ((!version && appVersion === highestVersion_1) || version === appVersion);
            });
        }
    }
    if (elementsWithCombinedVersion) {
        elementsCollection.push.apply(elementsCollection, Array.from(elementsWithCombinedVersion));
    }
    return elementsCollection;
}
exports.getElementsForApp = getElementsForApp;
function getAppKey(manifest, appParamsHelper) {
    var _a = appParamsHelper.rawAppParams, rawAppParams = _a === void 0 ? {} : _a;
    var _b = rawAppParams.configurationKey, configurationKey = _b === void 0 ? 'default' : _b, _c = rawAppParams.styleKey, styleKey = _c === void 0 ? 'default' : _c, _d = rawAppParams.ksysAppTemplateVersion, version = _d === void 0 ? 'v1.0.0' : _d, _e = rawAppParams.applicationCode, applicationCode = _e === void 0 ? '' : _e;
    return getAppKeyRaw(manifest.ksysAppTemplateId, configurationKey, styleKey, version, applicationCode);
}
exports.getAppKey = getAppKey;
function getAppKeyRaw(templateId, configurationKey, styleKey, version, applicationCode) {
    if (configurationKey === void 0) { configurationKey = 'default'; }
    if (styleKey === void 0) { styleKey = 'default'; }
    if (version === void 0) { version = 'v1.0.0'; }
    if (applicationCode === void 0) { applicationCode = ''; }
    return templateId + "-" + version + "|" + configurationKey + "|" + styleKey + (applicationCode.length > 0 ? "|" + applicationCode : '');
}
exports.getAppKeyRaw = getAppKeyRaw;
function appendCacheQueryString(fileName, assetRegister, cacheOptions) {
    var queryStringObj = {};
    if (assetRegister) {
        queryStringObj.lastModified = assetRegister.lastModified;
    }
    if (cacheOptions) {
        queryStringObj.cache = JSON.stringify(cacheOptions);
    }
    var queryString = Object.keys(queryStringObj).reduce(function (acc, key, index) {
        var value = queryStringObj[key];
        acc = "" + acc + (index > 0 ? '&' : '') + key + "=" + encodeURIComponent(value);
        return acc;
    }, '');
    if (queryString && queryString.length > 0) {
        var separator = fileName.includes('?') ? '&' : '?';
        fileName = "" + fileName + separator + queryString;
    }
    return fileName;
}
exports.appendCacheQueryString = appendCacheQueryString;
//# sourceMappingURL=utils.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys-app-template/dist/appsManager/utils.js
// module id = 149
// module chunks = 1